var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.visible),expression:"!visible"}],staticClass:"app-main",class:{p0: _vm.minimalistPage},attrs:{"element-loading-spinner":"el-icon-loading"}},[(_vm.visible)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }